module.exports = __webpack_public_path__ + "static/media/Kristián-dort-169x300.db58388f.jpg";